
  export const NOTES_RECEIVED = "NOTES_RECEIVED";
  export const SET_NOTE = "SET_NOTE";
  export const CREATE_NOTE = "CREATE_NOTE";
  export const SET_PROPERTY_NOTE = "SET_PROPERTY_NOTE";
  